var render = function render(){var _vm=this,_c=_vm._self._c;return _c('code-block',{staticClass:"highlight",attrs:{"max-height":_vm.maxHeight}},[_c('span',{directives:[{name:"safe-html",rawName:"v-safe-html",value:(_vm.highlighted),expression:"highlighted"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }